/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfCampaingDto } from "../models/AjaxResponseOfCampaingDto";
import type { AjaxResponseOfCreateCampaingResponseDto } from "../models/AjaxResponseOfCreateCampaingResponseDto";
import type { AjaxResponseOfMakeCallOutput } from "../models/AjaxResponseOfMakeCallOutput";
import type { AjaxResponseOfPagedResultDtoOfCallDto } from "../models/AjaxResponseOfPagedResultDtoOfCallDto";
import type { AjaxResponseOfPagedResultDtoOfCampaingDto } from "../models/AjaxResponseOfPagedResultDtoOfCampaingDto";
import type { CampaignStatus } from "../models/CampaignStatus";
import type { CampaignType } from "../models/CampaignType";
import type { CreateCampaingDto } from "../models/CreateCampaingDto";
import type { CreateOrEditCampaingDto } from "../models/CreateOrEditCampaingDto";
import type { MakeCallInput } from "../models/MakeCallInput";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class TelecomAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfPagedResultDtoOfCampaingDto Success
   * @throws ApiError
   */
  public getAllCampaings({
    filter,
    campaignTypeFilter,
    statusFilter,
    minStartTimeFilter,
    maxStartTimeFilter,
    sorting,
    skipCount,
    maxResultCount,
  }: {
    filter?: string;
    campaignTypeFilter?: CampaignType;
    statusFilter?: CampaignStatus;
    minStartTimeFilter?: string;
    maxStartTimeFilter?: string;
    sorting?: string;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfPagedResultDtoOfCampaingDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/telecom",
      query: {
        filter: filter,
        campaignTypeFilter: campaignTypeFilter,
        statusFilter: statusFilter,
        minStartTimeFilter: minStartTimeFilter,
        maxStartTimeFilter: maxStartTimeFilter,
        sorting: sorting,
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public deleteCall({ id }: { id: string }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/telecom/calls/{id}",
      path: {
        id: id,
      },
    });
  }
  /**
   * @returns AjaxResponseOfCreateCampaingResponseDto Success
   * @throws ApiError
   */
  public createCampaing({
    requestBody,
  }: {
    requestBody?: CreateCampaingDto;
  }): CancelablePromise<AjaxResponseOfCreateCampaingResponseDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/telecom/campaings",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public deleteCampaing({ id }: { id: number }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/telecom/campaings/{id}",
      path: {
        id: id,
      },
    });
  }
  /**
   * @returns AjaxResponseOfCampaingDto Success
   * @throws ApiError
   */
  public getCampaingForEdit({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfCampaingDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/telecom/campaings/{id}",
      path: {
        id: id,
      },
    });
  }
  /**
   * @returns AjaxResponseOfCampaingDto Success
   * @throws ApiError
   */
  public updateCampaing({
    id,
    requestBody,
  }: {
    id: number;
    requestBody?: CreateOrEditCampaingDto;
  }): CancelablePromise<AjaxResponseOfCampaingDto> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/telecom/campaings/{id}",
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfMakeCallOutput Success
   * @throws ApiError
   */
  public makeCall({
    requestBody,
  }: {
    requestBody?: MakeCallInput;
  }): CancelablePromise<AjaxResponseOfMakeCallOutput> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/telecom/make-call",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfPagedResultDtoOfCallDto Success
   * @throws ApiError
   */
  public getRecentCalls({
    filter,
    statusFilter,
    maxResultCount,
    skipCount,
  }: {
    filter?: string;
    statusFilter?: number;
    maxResultCount?: number;
    skipCount?: number;
  }): CancelablePromise<AjaxResponseOfPagedResultDtoOfCallDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/telecom/recent-calls",
      query: {
        filter: filter,
        statusFilter: statusFilter,
        maxResultCount: maxResultCount,
        skipCount: skipCount,
      },
    });
  }
}
